import Keycloak from 'keycloak-js';
const keycloak = new Keycloak({
  url: process.env.REACT_APP_KEYCLOAK_URL || 'https://keycloak.flareon.ru',
  realm: process.env.REACT_APP_KEYCLOAK_REALM || 'hr',
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'hr-frontend-client',
});

export default keycloak;
